import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ClientSettings {
  rotateSeats: boolean;
  sound: boolean;
  haptic: boolean;
  highContrast: boolean;
  showHints: boolean;
}

interface State extends ClientSettings {
  set: <K extends keyof ClientSettings>(k: K, v: ClientSettings[K]) => void;
}

export const useSettings = create<State>()(
  persist(
    (set) => ({
      rotateSeats: true,
      sound: true,
      haptic: true,
      highContrast: false,
      showHints: true,
      set: (k, v) => set({ [k]: v } as any),
    }),
    { name: 'durak-settings' },
  ),
);
